export default __webpack_public_path__ + "static/media/mesh.22a664e9.gif";